import { CaregiverResidentAdlPageContent } from "../../caregiver/pages/CaregiverResidentAdlPage";

const SharedResidentAdlPage = () => (
  <CaregiverResidentAdlPageContent sharedMode />
);

export default SharedResidentAdlPage;
